import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import { GetAllPR_TypeOfJobOpportunity } from "../../Redux/Reducers/ReportStage/TypeOfJobOpportunityDropdown";
import {
  AddJobOpportunitiesDuringProjectData,
  GetOneJobOpportunitiesDuringProjectData,
  restValidateJobOpportunitiesDuringProject,
  UpdateJobOpportunitiesDuringProjectData,
  ValidateJobOpportunitiesDuringProject,
} from "../../Redux/Reducers/ReportStage/JobOpportunitiesDuringProject";
import LoaderAHSF from "../../Components/LoaderAHSF";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import InputAHSF from "../../Components/InputAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const EditJobOpportunities = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);

  const state = useSelector((state) => {
    return {
      //////////////////////////////////////////////////////////
      TypeOfJobOpportunityDropDown:
        state.TypeOfJobOpportunityDropDown.TypeOfJobOpportunityDropDown,
      OneJobOpportunitiesDuringProject:
        state.JobOpportunitiesDuringProject.OneJobOpportunitiesDuringProject,
      UpdateJobOpportunitiesDuringProject:
        state.JobOpportunitiesDuringProject.UpdateJobOpportunitiesDuringProject,
      JobOpportunitiesDuringProjectValidate:
        state.JobOpportunitiesDuringProject
          .JobOpportunitiesDuringProjectValidate,
      loadingOneJobOpportunitiesDuringProject:
        state.JobOpportunitiesDuringProject
          .loadingOneJobOpportunitiesDuringProject,
    };
  });

  console.log(state.OneJobOpportunitiesDuringProject, "qasem");
  // Gender options for dropdown
  const MaleOrFemale = [
    { gender: "ذكر", KeyValue: true },
    { gender: "انثى", KeyValue: false },
  ];
  // State for the project admin form

  const [JobOpportunitiesList, setJobOpportunitiesList] = useState({
    pR_JobOpportunitiesDuringProjectId:
      state.OneJobOpportunitiesDuringProject
        ?.pR_JobOpportunitiesDuringProjectId,
    natureOfOpportunity:
      state.OneJobOpportunitiesDuringProject?.natureOfOpportunity,
    gender: state.OneJobOpportunitiesDuringProject?.gender,
    pR_TypeOfJobOpportunityId:
      state.OneJobOpportunitiesDuringProject?.pR_TypeOfJobOpportunityId,

    pR_ReportsStagesGuid: stageGuid,
  });
  // Effect to fetch TypeOfJobOpportunity data
  useEffect(() => {
    dispatch(GetAllPR_TypeOfJobOpportunity());
  }, []);
  // Function to update an existing project management team member

  const AddJobOpportunities = async () => {
    const validationList = await dispatch(
      ValidateJobOpportunitiesDuringProject({
        pR_TypeOfJobOpportunityId:
          JobOpportunitiesList.pR_TypeOfJobOpportunityId,
        gender:
          JobOpportunitiesList.gender === "true"
            ? true
            : JobOpportunitiesList.gender === "false"
            ? false
            : null,
        natureOfOpportunity: JobOpportunitiesList.natureOfOpportunity,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If no validation errors, add team member
    if (validationList.payload.length === 0) {
      await dispatch(
        AddJobOpportunitiesDuringProjectData({
          natureOfOpportunity: JobOpportunitiesList.natureOfOpportunity,
          gender: JobOpportunitiesList.gender == "true" ? true : false,
          pR_TypeOfJobOpportunityId:
            JobOpportunitiesList.pR_TypeOfJobOpportunityId,
          pR_ReportsStagesGuid: JobOpportunitiesList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  const UpdateJobOpportunities = async () => {
    const validationList = await dispatch(
      ValidateJobOpportunitiesDuringProject({
        pR_TypeOfJobOpportunityId:
          JobOpportunitiesList.pR_TypeOfJobOpportunityId,
        gender: JobOpportunitiesList.gender == "true" ? true : false,
        natureOfOpportunity: JobOpportunitiesList.natureOfOpportunity,
      })
    );
    // If no validation errors, update team member
    if (validationList.payload.length === 0) {
      await dispatch(
        UpdateJobOpportunitiesDuringProjectData({
          pR_TypeOfJobOpportunityId:
            JobOpportunitiesList.pR_TypeOfJobOpportunityId,
          natureOfOpportunity: JobOpportunitiesList.natureOfOpportunity,
          gender:
            JobOpportunitiesList.gender === "true" ||
            JobOpportunitiesList.gender == true
              ? true
              : JobOpportunitiesList.gender === "false" ||
                JobOpportunitiesList.gender == false
              ? false
              : null,

          pR_JobOpportunitiesDuringProjectId:
            JobOpportunitiesList.pR_JobOpportunitiesDuringProjectId,
          pR_ReportsStagesGuid: JobOpportunitiesList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  useEffect(() => {
    dispatch(restValidateJobOpportunitiesDuringProject());
  }, []);
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOneJobOpportunitiesDuringProjectData(
          props.pR_JobOpportunitiesDuringProjectId
        )
      );
    }
  }, [props.pR_JobOpportunitiesDuringProjectId]);
  useEffect(() => {
    if (
      !state.loadingOneJobOpportunitiesDuringProject &&
      Object.keys(props).length != 0
    ) {
      setJobOpportunitiesList({
        ...state.OneJobOpportunitiesDuringProject,
      });
    } else {
      setJobOpportunitiesList({
        natureOfOpportunity: null,
        gender: null,
        pR_TypeOfJobOpportunityId: null,
        pR_ReportsStagesGuid: JobOpportunitiesList.pR_ReportsStagesGuid,
      });
    }
  }, [state.OneJobOpportunitiesDuringProject]);

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  //to render html after loading ends
  return (
    <>
      {!state.loadingOneJobOpportunitiesDuringProject ? (
        <>
          <div className="AddEdite">
            <AllDropDownsAHSF
              fieldsName="JobOpportunityType"
              show={true}
              disabled={props.shouldDisableFields}
              arrayOoptionList={state.TypeOfJobOpportunityDropDown}
              KeyText={"typeOfJobOpportunityName"}
              KeyValue={"pR_TypeOfJobOpportunityId"}
              dropdownType={"normal"}
              onChange={(e) => {
                setJobOpportunitiesList({
                  ...JobOpportunitiesList,
                  pR_TypeOfJobOpportunityId: Number(e.target.value),
                });
              }}
              defaultValue={JobOpportunitiesList.pR_TypeOfJobOpportunityId}
              showValidationMessage={
                state.JobOpportunitiesDuringProjectValidate
                  ? state.JobOpportunitiesDuringProjectValidate.includes(
                      "JobOpportunityType"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <AllDropDownsAHSF
              fieldsName="Gender"
              show={true}
              disabled={props.shouldDisableFields}
              KeyText={"gender"}
              KeyValue={"KeyValue"}
              arrayOoptionList={MaleOrFemale}
              dropdownType={"normal"}
              onChange={(e) => {
                setJobOpportunitiesList({
                  ...JobOpportunitiesList,
                  gender: e.target.value,
                });
              }}
              defaultValue={JobOpportunitiesList.gender}
              showValidationMessage={
                state.JobOpportunitiesDuringProjectValidate
                  ? state.JobOpportunitiesDuringProjectValidate.includes(
                      "Gender"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="NatureOfOpportunity"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setJobOpportunitiesList({
                  ...JobOpportunitiesList,
                  natureOfOpportunity: e.target.value,
                });
              }}
              defaultValue={
                state.OneJobOpportunitiesDuringProject?.natureOfOpportunity
              }
              showValidationMessage={
                state.JobOpportunitiesDuringProjectValidate
                  ? state.JobOpportunitiesDuringProjectValidate.includes(
                      "NatureOfOpportunity"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!props.shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateJobOpportunities()
                        : AddJobOpportunities();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneJobOpportunitiesDuringProject} />
    </>
  );
};

export default EditJobOpportunities;
